import useSWR from 'swr'

import { sharedStaticConfig } from '@ngb-frontend/shared/config'

import type { RequestError } from '../error/RequestError'
import type { Driver, QueryConfig } from '@ngb-frontend/shared/types'

export const useDriver = (id?: string, query?: QueryConfig) => {
  const driverId = id || query?.country

  const countryCode = query?.country
  return useSWR<Driver, RequestError>(
    driverId && countryCode
      ? [sharedStaticConfig.apiRoutes.driver, { driverId, countryCode }]
      : null,
  )
}
